export const MAX_REMINDER_TIMES = 3;

export const REMINDER_MINUTE_BUCKETS = [0, 15, 30, 45] as const;

export const REMINDER_MINUTE_INTERVAL: number = 60 / REMINDER_MINUTE_BUCKETS.length;

export const REMINDER_TIME_REGEX = /^([01][0-9]|2[0-3]):(00|15|30|45)$/;
